export default {
  name: 'chaseSpin'
};